// extracted by mini-css-extract-plugin
export default {"loader":"Loader__loader--ykjIY","infinite":"Loader__infinite--CHYs1","loader-animation":"Loader__loader-animation--DwK5E"};